// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.I8eeV{flex-direction:column;width:100%;border-radius:8px;overflow:hidden;background-color:#fcfcfd;box-shadow:0 4px 12px rgba(40,40,99,.06);margin-block-end:24px}.I8eeV+.I8eeV{margin-block-start:24px}.I8eeV.ftNiM{min-height:80px}.I8eeV._2UW2{box-shadow:0 0 0 1.5px #e86161}.tYoSs{display:flex;align-items:center;max-block-size:80px;padding-block:20px;padding-inline:32px;cursor:pointer;gap:8px;border-block-end:1px solid transparent}.I8eeV:not(.ftNiM) .tYoSs{border-block-end-color:#eaeaef}.KltLm{display:flex;align-items:center;align-self:center;margin-left:-4px;padding-right:0;width:0;overflow:hidden;opacity:0;transition:width .15s ease,opacity .15s ease,padding-right .15s ease;cursor:grab}.I8eeV:hover .KltLm{width:20px;padding-right:4px;opacity:1}.wxcIT{min-width:0;max-width:100%;gap:8px;border-radius:4px;padding:0 4px;margin:-4px;border:1px solid transparent;transition:border-color .2s ease;width:fit-content;flex-shrink:1}.wxcIT.nszZM{cursor:pointer}.wxcIT.nszZM:hover{border-color:#d4d4e0}.wxcIT.nszZM:hover .Q7O_N{color:#282863}.Q7O_N{display:inline-flex;align-items:center;background:none;border:none;padding:0;cursor:pointer;color:#696992;transition:color .2s ease}.pl5zq{display:flex;align-items:center;gap:4px;margin-inline-start:auto;flex-shrink:0}.ENN0j{width:1px;height:24px;background-color:#d4d4e0;margin:0 4px}.TrLyH{flex-direction:column;padding:32px;min-height:120px}.JPOzc{padding:0 32px 24px}.n3e8z{flex-direction:column;padding:16px 32px 24px;gap:8px;border-block-start:1px solid #eaeaef}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple300": `#c3b3fc`,
	"purple400": `#b4a1fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"card": `I8eeV`,
	"collapsed": `ftNiM`,
	"cardError": `_2UW2`,
	"header": `tYoSs`,
	"dragHandleSlot": `KltLm`,
	"titleArea": `wxcIT`,
	"editable": `nszZM`,
	"editIconButton": `Q7O_N`,
	"headerActions": `pl5zq`,
	"headerDivider": `ENN0j`,
	"contentArea": `TrLyH`,
	"displayScopeRow": `JPOzc`,
	"changesSection": `n3e8z`
};
export default ___CSS_LOADER_EXPORT___;
